import { Http } from '@mygpt/app/http';

export interface DeleteApiParamsFunction {
  // 数据集 ID
  datasetId: string;
  apiId: string;
}

/**
 * 删除问答属性
 * @param params
 * @returns
 */
export const deleteApiService = (params: DeleteApiParamsFunction) => {
  const { apiId, datasetId } = params;
  const { delete: deleteFn } = Http.use();
  return deleteFn(`/datasets/${datasetId}/functions/${apiId}`);
};

export const batchDeleteApiService = (params: { datasetId: string; apiIds: string[] }) => {
  const { apiIds, datasetId } = params;
  const { delete: _delete } = Http.use();
  return _delete(`/datasets/${datasetId}/functions/batch`, {
    params: {
      apiIds: apiIds.join(','),
    },
  });
};
